let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5OaeX")).then(() => parcelRequire('3Ehcx'));